var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 77.0002V1.00015H1V77.0002H77Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.044 52.4247L31.0484 48.4807C31.0501 46.9347 29.7981 45.68 28.2522 45.6783C26.706 45.6765 25.4513 46.9284 25.4496 48.4744L25.4396 57.5162C25.4368 59.9333 26.1665 62.2946 27.5325 64.2888L29.8307 67.6443L29.8243 73.3866",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2066 48.4865L36.2194 36.9076C36.221 35.4832 35.0675 34.327 33.6431 34.3255C32.2187 34.324 31.0627 35.4774 31.0612 36.9018L31.0482 48.4807",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3651 48.4922L41.3805 34.6194C41.3822 33.1948 40.2287 32.0388 38.8042 32.0373C37.3798 32.0356 36.2237 33.1892 36.2222 34.6136L36.2068 48.4865",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5236 48.4979L46.5355 37.7901C46.537 36.3657 45.3836 35.2095 43.9592 35.208C42.5346 35.2063 41.3786 36.3599 41.3771 37.7843L41.3652 48.4921",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6822 58.5001L51.6822 48.5037L51.6915 40.0299C51.6931 38.6054 50.5396 37.4493 49.1152 37.4478C47.6908 37.4463 46.5348 38.5997 46.5331 40.0241L46.5238 48.4979",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0751 73.4081L49.0818 67.4135C50.7736 64.551 51.6678 61.2876 51.6715 57.9625L51.6727 56.9211",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 76.8439L28.7999 74.8748C28.8001 74.6792 28.8388 74.4856 28.9139 74.305C28.9889 74.1244 29.0988 73.9603 29.2373 73.8222C29.3757 73.6841 29.54 73.5746 29.7208 73.4999C29.9016 73.4253 30.0953 73.387 30.2908 73.3872L48.6085 73.4074C49.4309 73.4085 50.0971 74.0761 50.0961 74.8986L50.0911 76.8675",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.769 21.447L36.6055 24.1873C37.7173 25.2615 39.4895 25.2309 40.5639 24.1191C41.6381 23.0071 41.6074 21.2349 40.4956 20.1607L33.9928 13.8784C32.2544 12.199 30.048 11.0856 27.6643 10.6849L23.6534 10.011L19.5237 6.02109",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0211 27.8972L37.6097 32.3302",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2543 35.5609C45.9676 34.54 45.8572 33.1253 44.933 32.2324L36.6055 24.1872",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5192 34.5846L29.4371 31.6071",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 32.5L22.2689 39.0268L28.3633 44.9144C29.1002 45.6264 30.151 45.8087 31.0518 45.4754",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14783 19.8661L10.459 24.0312C11.3458 27.2358 13.0748 30.1445 15.4662 32.4547L17.8507 34.7585",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0574 40.3449L25.853 35.3169",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8844 1.08303L19.163 4.25056C19.7547 4.82216 19.7708 5.76501 19.1994 6.35656L6.47214 19.5305C5.90055 20.122 4.95769 20.1383 4.36614 19.5667L1.0874 16.3992",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4112 33.3595L52.4894 36.0086C51.3439 37.0471 51.2572 38.8173 52.2957 39.9628C53.3343 41.1081 55.1047 41.1948 56.25 40.1563L62.9484 34.0831C64.739 32.4595 65.9958 30.3315 66.5531 27.9795L67.4908 24.022L71.7449 20.1648",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0242 32.187L45.8494 35.0656",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3319 30.3851L45.5595 28.3655",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8143 5.90349L54.3735 9.92994C51.1172 10.603 48.1006 12.1358 45.6372 14.3692L39.8923 19.578",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4314 19.8193C71.9839 20.4287 72.9259 20.4748 73.5353 19.9223L76.9126 16.8602",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6081 1.08319L59.2308 4.1453C58.6215 4.69785 58.5753 5.63964 59.1278 6.24901L71.5004 19.5",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.2cf73097786bd8a47f3eff6aa369a886.svg";
export { ForwardRef as ReactComponent };